import React from "react";
import Layout from '../../pages/include/layout';
import ProfileView from "./views/ProfileView";
import useProfile from "./hooks/profile.hook";

const Profile = props => {
    const profileHook = useProfile()

    if(profileHook?.loading) {
        return <></>

    } else {
        return (
            <>
                <Layout>
                    <ProfileView {...profileHook} />
                </Layout>
            </>
        )
    }

}

export default Profile;